module.exports = "/assets/38349135551e088a3eef7675097bd3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/G8.png
// module id = 1396
// module chunks = 0